"use client";

import { c as _c } from "react/compiler-runtime";
import { decode } from "he";
import React, { useRef, useState, useEffect } from "react";
import useAutosizeTextArea from "@/app/(main)/(club)/mes-clubs/[id]/utils/useAutosizeTextArea";
import { Club } from "@/TS/Interfaces/global_interfaces";
import { getSanitizedData } from "@/utils/getSanitizedData";
function TextAreaDashboard(t0) {
  const $ = _c(10);
  const {
    club
  } = t0;
  const textAreaRef = useRef(null);
  let t1;
  if ($[0] !== club.description) {
    t1 = club?.description ? decode(club.description ?? "") : null;
    $[0] = club.description;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [value, setValue] = useState(t1);
  let t2;
  let t3;
  if ($[2] !== club.description) {
    t2 = () => {
      setValue(club?.description ? decode(club.description ?? "") : null);
    };
    t3 = [club.description];
    $[2] = club.description;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  useAutosizeTextArea(textAreaRef, value, club);
  let t4;
  if ($[5] !== club || $[6] !== value) {
    t4 = value && club && <><div className="wysiwyg" dangerouslySetInnerHTML={{
        __html: getSanitizedData(value.replace(/^["']|["']$/g, ""))
      }} /></>;
    $[5] = club;
    $[6] = value;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <>{t4}</>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
export default TextAreaDashboard;